<template>
    <div class="app-container">
        <div class="guide-container" :class="isCollapse?'guide-collapse':''">
            <pang-title :text="$router.lang.get('遊戲 指南')" eng="Guidance"/>
            <div class="guide" v-for="item in data" :key="item.news_type">
                <div class="guide-tab-container">
                    <pang-tab :tabs="[NEWS_TYPES[item.news_type]]"/>
                </div>
                <div class="guide-subtypes">
                    <div class="guide-subtype-container" v-for="subtype in item.subtypes"  :key="subtype.news_sub_type">
                        <div class="guide-title">
                            <div>{{ subtype.news_sub_type }}</div>
                        </div>
                        <div class="guide-articles">
                            <div
                            v-for="subitem in subtype.news" :key="subitem.id"
                            @click="gotoNews(subitem)">{{ subitem.article.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { useScreenState } from '../../store';
import request from '../../api/request'
import { PangTitle, PangTab } from '../../components'
import enums from '../../utils/enums.js'
import message from '../../utils/message'
import browser from '../../utils/browser';

export default {
    name: 'guide',
    components: {
        PangTitle,
        PangTab,
    },
    data () {
        return {
            screenState: useScreenState(),
            NEWS_TYPES: enums.NEWS_TYPES,
            data: [
                {
                    news_type:1,
                    subtypes: [],
                },
                {
                    news_type: 2,
                    subtypes: [],
                },
                {
                    news_type: 3,
                    subtypes: []
                },
                {
                    news_type: 4,
                    subtypes: []
                },
            ],
        };
    },
    computed: {
        isCollapse() {
        return this.screenState.screenWidth < 900;
        },
    },
    methods: {
        gotoNews (news) {
            let url = '/news/guide/' + news.id
            if (browser.isPc)
                window.open(url)
            else
                this.$router.push(url)
        },
        mapTypes (news_type, results) {
            let mapping = {}
            let res =  results.reduce(function (pre, curr) {
                if (curr.news_type == news_type) {
                    if (mapping[curr.news_sub_type]) {
                        mapping[curr.news_sub_type].push(curr)
                    }
                    else {
                        mapping[curr.news_sub_type] = [curr]
                        pre.push({
                            news_sub_type: curr.news_sub_type,
                            news: mapping[curr.news_sub_type]})
                    }
                }
                return pre
            }, [])
            return res
        },
        get_news () {
            let params ={
                limit: 99999999,
            }
            let _this = this
            request.get('/news' , params, this).then(function (res) {
                if (res.status == 200) {
                    for (let i=0; i<_this.data.length; i++)
                        _this.data[i].subtypes = _this.mapTypes(_this.data[i].news_type, res.data.results)
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
    },
    mounted () {
        this.get_news()
    },
}
</script>

<style scoped>

.guide-container {
    max-width: 1040px;
    width: 90vw;
    margin: auto;
    color: #686A6E;
    margin-bottom: 200px;
}

.guide-subtype-container {
    display: flex;
    margin-bottom: 20px;
}

.guide-articles {
    flex-direction: row;
    margin-left: 17px;
}

.guide-tab-container {
    border-bottom: 1px solid rgba(206, 206, 206, 0.4);
    margin-bottom: 45px;
}

.guide-title > div {
    width: 110px;
    line-height: 30px;
    background: #C6A86C;
    border-radius: 15px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
} 

.guide-articles > div{
    padding: 0 20px;
    line-height: 19px;
    margin: 5.5px 0;
    border-right: 1px solid #686A6E;
    display: inline-block;
    cursor: pointer;
}

.guide-articles > div:last-child{
    border-right: none;
}

.guide-subtypes {
    margin-bottom: 57px;
}

.guide-collapse {
    margin-bottom: calc(10vw + 20px);
}

.guide-collapse .guide-title > div {
    width: calc(8vw + 38px);
    font-size: calc(1vw + 5px);
}

.guide-collapse .guide-articles {
    margin-left: 2vw;
}

.guide-collapse .guide-articles > div {
    padding: 0 calc(2vw + 2px);
}

.guide-collapse .guide-subtypes {
    margin-bottom: calc(6vw + 3px);
}

</style>
